









































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class NavigationDrawer extends Vue {

    @Prop(Boolean) show!: boolean
    @Prop(Array) topItems!: Array<object>
    @Prop(Array) bottomItems!: Array<object>
    @Prop(String) routerPath!: string
}
